export const fonts = [
  'Quicksand',
  'Lato',
  'Gloria Hallelujah',
  'Work Sans',
  'Playfair Display',
  'Libre Franklin',
  'Space Mono',
  'Rubik',
  'Cormorant',
  'Fira Sans',
  'Eczar',
  'Alegreya Sans',
  'Alegreya',
  'Chivo',
  'Lora',
  'Source Sans Pro',
  'Source Serif Pro',
  'Roboto',
  'Roboto Slab',
  'Poppins',
  'BioRhyme',
  'Archivo Narrow',
  'Libre Baskerville',
  'Crimson Text',
  'Karla',
  'Montserrat',
  'Old Standard TT',
  'Spectral',
  'Domine',
  'Bitter',
  'Gentium Basic',
  'PT Sans',
  'PT Serif',
  'Lato',
  'Cardo',
  'Neuton',
  'Open Sans',
  'Inconsolata',
  'Cabin',
  'Raleway',
  'Anonymous Pro',
  'Arvo',
  'Merriweather'
];

export const defaultFont = fonts[0];


// @todo: use Cache api to cache fonts 
// let loadedFonts = [];
// export function loadFont(fontName) {

//   if (!fontName || loadedFonts.includes(fontName)) return;
//   loadedFonts.push(fontName);
//   // console.log('loading font ..............', fontName)
//   return window.WebFont.load({
//     google: {
//       families: [fontName]
//     }
//   });
// }
